// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"9c114c66","817":"76b47dc0"}[chunkId] + ".chunk.js";
};